import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { querySendOutScope } from '@/api/notice/noticeApi.js';
export default {
  data: function data() {
    return {
      labelCol: {
        span: 4
      },
      wrapperCol: {
        span: 20
      },
      formObject: {
        title: '',
        department: '',
        reportPerson: '',
        mainItems: '',
        time: '',
        departmentCN: {}
      },
      userInfo: this.$hdk.userInfo.get(),
      rules: {},
      value: 1,
      addFile: 2,
      //补档文件状态
      accessory: 2,
      //附件资料状态
      legalOpinion: 2,
      //法律意见书状态
      justiceOpinion: 2,
      //风控法务部审查意见书状态
      departmentOpinion: 2,
      //相关部门审查意见表状态
      options: []
    };
  },
  created: function created() {
    var userInfo = this.userInfo;
    this.formObject.reportPerson = userInfo.userName;
    // 级联数据处理
    this.options = _.map(userInfo.organPostTree, function (item) {
      item.postList = _.map(item.postList, function (subItem) {
        return {
          label: subItem.postName,
          value: subItem.postId,
          children: null
        };
      });
      return {
        label: item.organName,
        value: item.organId,
        children: item.postList
      };
    });
  },
  methods: {
    onDepartmentOpinion: function onDepartmentOpinion() {},
    onJusticeOpinion: function onJusticeOpinion() {},
    onLegalOpinion: function onLegalOpinion() {},
    onAddFile: function onAddFile() {},
    onAccessory: function onAccessory() {},
    callback: function callback() {},
    backPage: function backPage() {
      this.$router.go(-1);
    },
    onChange: function onChange(value, dateString) {},
    onOk: function onOk(value) {},
    /***
     *  点击上传
     */
    handleChange: function handleChange(info) {
      var status = info.file.status;
      if (status !== 'uploading') {}
      if (status === 'done') {
        this.$message.success("".concat(info.file.name, " file uploaded successfully."));
      } else if (status === 'error') {
        this.$message.error("".concat(info.file.name, " file upload failed."));
      }
    },
    /**
     * 级联选择
     */
    onOrganAndJob: function onOrganAndJob(value) {
      var _this = this;
      var $set = this.$set,
        formObject = this.formObject;
      // 组织岗位赋值
      $set(formObject, 'organId', value[0]);
      $set(formObject, 'postId', value[1]);
      this.formObject.customize = {};
      this.formObject.customize.organId = value[0];
      this.formObject.customize.postId = value[1];
      var newOrganIdAndPost = {
        organId: value[0],
        postId: value[1]
      };
      querySendOutScope(newOrganIdAndPost).then(function (res) {
        _this.allDisabled = res.data.data;
      });
      this.options.forEach(function (item) {
        if (_this.formObject.organId == item.value) {
          _this.formObject.departmentCN.organIdName = item.label;
          item.children.forEach(function (items) {
            if (_this.formObject.postId == items.value) {
              _this.formObject.departmentCN.postIdName = items.label;
            }
          });
        }
      });
    },
    filterOption: function filterOption(inputValue, path) {
      return path.some(function (option) {
        return option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
      }) || path.some(function (option) {
        return option.value.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
      });
    }
  }
};